import { useState, useEffect } from 'react';
import './LightBeige.css';
import './LightBlue.css';
import config from '../../../config';
import ParagraphTile from './ParagraphTile';
import useViewPairing from '../modal/useViewPairing';
import { AdvisoryContent } from '../../../common/global-types/AdvisoryContent';
import Modal from '../modal/Modal';
import ListTile from './ListTile';

type TileProps = {
  content: AdvisoryContent;
  dispatchElementLoadedEvent: (event: CustomEvent) => void;
  viewId: number | undefined;
  setViewId: (viewId: number | undefined) => void;
  proxyPath: string | null;
};

function Tile(
  {
    content,
    dispatchElementLoadedEvent,
    viewId,
    setViewId,
    proxyPath
  }: TileProps
) {
  const [tileViewTheme, setTileViewTheme] = useState<string | undefined>(
    content.contentViews?.find((cv) => cv.contentViewId === viewId)?.viewTheme?.toLowerCase()
  );

  const { primaryViewId, modalViewId } = useViewPairing(
    viewId,
    content.contentViews!,
    content.initialView
  );

  useEffect(() => {
    setTileViewTheme(content.contentViews?.find((cv) => cv.contentViewId === primaryViewId)?.viewTheme?.toLowerCase());
  }, [content.contentViews, primaryViewId]);

  useEffect(() => {
    const element: HTMLElement | null = document.querySelector('[data-name="advisory-recommendation"]');

    if (element) {
      element.style.backgroundColor = tileViewTheme === 'lightblue' ? '#e1e9f6' : '#faf9f7';

      if (!element.classList.contains('if')) element.classList.add('if');

      if (!element.classList.contains('navigational-card')) element.classList.add('navigational-card');

      if (!element.classList.contains('mypages-navigational-card')) element.classList.add('mypages-navigational-card');

      if (!element.classList.contains('lifestyle')) element.classList.add('lifestyle');
    }

    dispatchElementLoadedEvent(
      new CustomEvent(
        config.ADVISORY_RECOMMENDATION_CUSTOM_ELEMENT_LOADED_EVENT,
        { detail: content.advisorySegmentName }
      )
    );
  }, [tileViewTheme]);

  return (
    <>
      {content.contentViews?.find((cv) => cv.contentViewId === primaryViewId)?.viewLayout === 'paragraph'
        && (
          <ParagraphTile
            content={content}
            viewId={primaryViewId}
            setViewId={setViewId}
            viewTheme={tileViewTheme}
            proxyPath={proxyPath}
          />
        )}
      {content.contentViews?.find((cv) => cv.contentViewId === primaryViewId)?.viewLayout === 'list'
        && (
          <ListTile
            content={content}
            viewId={primaryViewId}
            setViewId={setViewId}
            viewTheme={tileViewTheme}
            proxyPath={proxyPath}
          />
        )}
      <Modal
        content={content}
        viewId={modalViewId}
        setViewId={setViewId}
        proxyPath={proxyPath}
      />
    </>
  );
}

export default Tile;
